import {BaseComponent, Collapse} from 'bootstrap';
import ready, {HTML} from './Helper';
import ApplicationForm from './Component/applicationForm';
import initUploadFields from './Component/uploadFields';
import scrollToFormError from './Component/scrollToFormError';
import damageReportForm from './Component/damageReportForm';
import parsleyValidation from './Component/parsleyValidation';
import realEstateGroupAccordion from './Component/realEstateGroupAccordion';
import faqGroupAccordion from './Component/faqGroupAccordion';
import initFixedHeader from './Component/fixedHeader';
import initNav from './Component/nav';
import initMapZoom from './Component/mapZoom';
import initMapMarkers from './Component/mapMarkers';
import initializeFancybox from './Component/fancybox';
import residentialMarketMap from './Component/residentialMarketMap';
import FaqSearch from './Component/faqSearch';
import RealEstateGroupsCarousel from './Component/realEstateGroupsCarousel';
import initResidentialMarketItemFilter from './Component/residentialMarketItemFilter';

import {
  isNil
} from './Helper'

ready(() => {

  HTML.classList.add('is-loaded');

  const applicationForm = document.querySelector('#application__form');
  if (!isNil(applicationForm)) {
    new ApplicationForm(applicationForm);
  }

  damageReportForm();
  parsleyValidation();
  realEstateGroupAccordion();
  initResidentialMarketItemFilter();
  faqGroupAccordion();
  initUploadFields();
  scrollToFormError();

  const fixedHeader = document.querySelector('#header');
  if (!isNil(fixedHeader)) {
    initFixedHeader(fixedHeader);
  }

  initNav();
  // unhide initially hidden <nav>
  const navi = document.querySelector('#nav');
  if (!isNil(navi)) {
    navi.classList.remove('hidden');
  }


  const experienceMap = document.querySelector('#map');
  if (!isNil(experienceMap)) {
    initMapZoom();
    initMapMarkers();

    const poiToggle = document.querySelector('.poi-toggle');
    poiToggle.addEventListener('click', highlightPois);

    function highlightPois(e) {
      e.preventDefault();
      experienceMap.classList.toggle('highlight');
      poiToggle.classList.toggle('active');
    }
  }

  initializeFancybox();

  const residentialMarketMapContainer = document.querySelector('#residentialmarket__map');
  if (!isNil(residentialMarketMapContainer)) {
    new residentialMarketMap(residentialMarketMapContainer);
  }

  const faqSearchInput = document.getElementById('faq__search');
  if (!isNil(faqSearchInput)) {
    new FaqSearch(faqSearchInput);
  }

  const realEstateGroupsCarousel = document.querySelector('.realestate-groups-carousel');
  if (!isNil(realEstateGroupsCarousel)) {
    new RealEstateGroupsCarousel(realEstateGroupsCarousel);
  }


});
